import script from "./Thumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./Thumbnail.vue?vue&type=script&setup=true&lang=js"

import "./Thumbnail.vue?vue&type=style&index=0&id=57b42534&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b42534"]])

export default __exports__